import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.pesquisa(payload).then(res => {
        dispatch('ActionSetListaTrabalhadores',res)
    }).catch(err => {
        dispatch('ActionSetListaTrabalhadores',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.delete(payload).then(res => {
        
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSalarioBase = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.salariobase(payload).then(res => {
        dispatch('ActionSetSalarioBase',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionDuplicar = ({dispatch},payload)=>{
    return serves.boletinstabelatrabalhadores.duplicar(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetListaTrabalhadores = ({commit},payload) =>{
    commit(types.SET_TRABALHADORES,payload)
}
export const ActionSetSalarioBase = ({commit},payload) =>{
    commit(types.SET_SALARIOBASE,payload)
}
